import tw from 'twin.macro';

export const Wrapper = tw.div`
  w-full flex flex-col gap-4 items-start justify-center
`;
